import axios from "/src/axios.js";

async function getBooks(subjectCode, locale = "en") {
  try {
    const url = `https://preprodms.embibe.com/coobo_ms/book-list/${subjectCode}?locale=${locale}`;
    const response = await axios.get(url);
    return Promise.resolve(response.data || {});
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getUnits(subjectCode, locale = "en") {
  const books = await getBooks(subjectCode, locale);
  const bigBook = books.find(b => b.type === "big-book");
  if (bigBook) {
    const url = `https://preprodms.embibe.com/coobo_ms/big-book/${bigBook.id}?locale=${locale}&ignore-empty=true`
    const {data: book} = await axios.get(url);
    if (book && book.hierarchy) return book.hierarchy;
  }
  return [];
}
